// extracted by mini-css-extract-plugin
export default {"services":"FrameComponent_services__aSetJ","divtrackSeparator":"FrameComponent_divtrackSeparator__p89X-","servicesParent":"FrameComponent_servicesParent__gk-WW"};